import { SpinningDiv } from '@cibo/ui'
import Cached from '@mui/icons-material/Cached'
import Check from '@mui/icons-material/Check'
import Error from '@mui/icons-material/Error'
import { Fade, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSaveIndicator } from './SaveIndicatorProvider'

export const SaveIndicator = ({ ns }: { ns?: string }) => {
  const { t } = useTranslation('@cibo/impact/SaveIndicator')
  const { isDirty, isError, isSaving } = useSaveIndicator()

  return (
    <Fade in={isDirty}>
      <Stack direction="row" spacing={1.5} alignItems={'center'}>
        {isSaving ? (
          <>
            <SpinningDiv timingFunction="ease-in-out">
              <Cached fontSize={'small'} color="success" />
            </SpinningDiv>
            <Typography variant="body2" color="success.main">
              {t('saving', { ns })}
            </Typography>
          </>
        ) : isError ? (
          <>
            <Error fontSize={'small'} color="error" />
            <Typography variant="body2" color="error">
              {t('error', { ns })}
            </Typography>
          </>
        ) : (
          <>
            <Check fontSize={'small'} color="success" />
            <Typography variant="body2" color="success.main">
              {t('success', { ns })}
            </Typography>
          </>
        )}
      </Stack>
    </Fade>
  )
}
